import { render, staticRenderFns } from "./ItemAssets.vue?vue&type=template&id=63ca38b8&"
import script from "./ItemAssets.vue?vue&type=script&lang=js&"
export * from "./ItemAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports